
import React, { Fragment, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, CircularProgress, FormControl, IconButton, InputLabel, MenuItem, Paper, Popper, Select, TextField } from '@mui/material';
import EditIcon from "@mui/icons-material/Edit";
import ModalContainer from '../../../components/ModalContainer';
import Alert from '../../../utils/Alert';
import { contractorAssignmentService, getContractorDetailsService, getContractorListService } from '../../../services/usersServices';
import { useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import GetField from '../../../components/GetField';
import * as Yup from "yup";
import { updateQcStatus } from '../../../services/servicesServices';

const options = [
    {
        value: "a",
        text: "قبول"
    }, 
    {
        value: "r",
        text: "غیر قابل قبول"
    }
];

const QualityControlRecord = ({ rowData }) => { 
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = async () => {
        setOpen(false);
    };
    const navigate = useNavigate();

    const initialValues = {
        qc_status: rowData.qc_status === "c" ? "" : rowData.qc_status,
        quality_percentage: rowData.quality_percentage ? rowData.quality_percentage : "",
        delay: rowData.delay ? rowData.delay : "0"
    }

    const validationSchema = Yup.object().shape({
        qc_status: Yup.string().required("لطفا نتیجه کنترل کیفیت را وارد کنید"),
        quality_percentage: Yup.number().required("لطفا درصد کیفیت را وارد کنید")  
             .min(0, "لطفا یک عدد بین ۰ تا ۱۰۰ وارد کنید")  
             .max(100, "لطفا یک عدد بین ۰ تا ۱۰۰ وارد کنید"),  
        delay: Yup.number().required("لطفا تعداد روز تاخیر را وارد کنید")  
             .min(0, "تاخیر نمی‌تواند منفی باشد")  
             .max(30, "تاخیر بیش از ۳۰ روز نمی‌تواند باشد")  
    });

    const onSubmit = async (values) => {
        try {
            const response = await updateQcStatus(rowData.code, values);
            if (response.status === 200) {
                handleClose(); 
                window.location.reload();
            }
        }catch (error) {
            Alert("خطا!", "در ثبت نتیجه کنترل کیفیت مشکلی پیش آمده!", "error");
        }
    };


    return (
        <>
        <span>
            <IconButton
            onClick={handleOpen}
            sx={{ mx: "0.25rem" }}
            >
                <EditIcon className="text-yellow-400" />
            </IconButton>
        </span>
        <ModalContainer
            alwaysOpen={false}
            onClose={handleClose}
            isOpen={open}
            fullscreen={false}
            title={"کنترل کیفیت"}
        >
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => onSubmit(values)}
                validationSchema={validationSchema}
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className='flex flex-col items-center'>
                            <div className='mb-5 w-full md:w-3/5 max-w-screen-sm'>
                                <GetField
                                    control="select"
                                    name="qc_status"
                                    options={options}
                                    label="نتیجه کنترل:"
                                    title="مشخص نشده"
                                    formik={formik}
                                />
                            </div>
                            <div className='mb-5 w-full md:w-3/5 max-w-screen-sm'>
                                <GetField
                                    control="input"
                                    name="quality_percentage"
                                    type="number"
                                    label="کیفیت (%)"
                                    formik={formik}
                                />
                            </div>
                            <div className='mb-5 w-full md:w-3/5 max-w-screen-sm'>
                                <GetField
                                    control="input"
                                    name="delay"
                                    type="number"
                                    label="تاخیر (روز)"
                                    formik={formik}
                                />
                            </div>
                            <div className='w-full text-center mt-4'>
                                <GetField
                                    control="submitbutton"
                                    formik={formik}
                                    text={"ثبت"}
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
        </>

    );
}

export default QualityControlRecord;